// src/pages/Help.js
import React from 'react';
import { LifeBuoy, Mail, FileText } from 'lucide-react';

const Help = () => {
  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <h1 className="text-2xl font-bold text-gray-800 mb-4 flex items-center">
        <LifeBuoy className="h-6 w-6 mr-2 text-blue-600" />
        Central de Ajuda
      </h1>

      <div className="bg-white rounded-xl shadow-md p-6 space-y-6">
        <section>
          <h2 className="text-lg font-semibold text-gray-700 mb-2 flex items-center">
            <Mail className="h-5 w-5 mr-2 text-green-600" />
            Suporte por E-mail
          </h2>
          <p className="text-sm text-gray-600">
            Em caso de dúvidas, entre em contato conosco pelo e-mail: 
            <strong> suporte@empresa.com</strong>
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-700 mb-2 flex items-center">
            <FileText className="h-5 w-5 mr-2 text-purple-600" />
            Documentação
          </h2>
          <p className="text-sm text-gray-600">
            Confira nossa documentação completa sobre a plataforma, tutoriais e FAQs
            em nosso site oficial: <a href="https://docs.empresa.com" className="text-blue-600 hover:underline">docs.empresa.com</a>.
          </p>
        </section>

        <section>
          <h2 className="text-lg font-semibold text-gray-700 mb-2">Perguntas Frequentes</h2>
          <ul className="list-disc list-inside text-sm text-gray-600 space-y-2">
            <li><strong>Como redefinir minha senha?</strong>  
              - Acesse a tela de <em>Esqueci minha senha</em> no login.
            </li>
            <li><strong>Onde vejo minhas campanhas de marketing?</strong>  
              - Acesse o menu Tráfego Pago na barra lateral.
            </li>
            <li><strong>Como gerenciar usuários?</strong>  
              - Somente administradores têm acesso ao menu Gerenciamento de Usuários.
            </li>
          </ul>
        </section>
      </div>
    </div>
  );
};

export default Help;
